import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from './../api.service';
import { CommonService } from '../shared/common.service';
import { Study, Crc } from '../study.model';

@Component({
  selector: 'app-study-details',
  templateUrl: './study-details.component.html',
  styleUrls: ['./study-details.component.scss']
})
export class StudyDetailsComponent {

  studyDetails: any = {};
  subjectId: string;
  participantId: string;
  subjectInitial: string;
  groupedStudies: any[] = [];
  name: string = '';
  studyId: any = '';
  templateid: any = '';
  centers: string = '';
  studyForm: any;
  subjectForm: any;
  editSubjectForm: any;
  editingSubject: any = null;
  error: string;

  studyCrcId: string; // New variable to store studyCrcId
  passedSiteLocation: string = ''; // Store the site location passed from study-crc-list
  userRole: string = '';
  canAddDeleteSubjects: boolean = true;
  
  // Freeze/Unfreeze properties
  currentSubject: any = null;
  isFreezing: boolean = false;
  isLocked: boolean = false;
  freezeEmail: string = '';
  freezePassword: string = '';
  freezeReason: string = '';
  freezeError: string = '';
  showFreezePassword: boolean = false;
  
  // Lock properties
  lockEmail: string = '';
  lockPassword: string = '';
  lockReason: string = '';
  lockError: string = '';
  showLockPassword: boolean = false;

  currentUser: any = null;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    public commonService: CommonService,
  ) {
    this.subjectForm = this.fb.group({
      subjectId: ['', Validators.required],
      participantId: [''], // PARTICIPANT ID - optional
      subjectInitial: [''],
    });
    this.editSubjectForm = this.fb.group({
      subjectId: ['', Validators.required],
      participantId: [''],
      subjectInitial: [''],
    });
  }

 
    ngOnInit(): void {
      // Get user role and check if user can add/delete subjects
      const userData = this.commonService.getUserData();
      this.currentUser = userData;
      this.userRole = userData?.designation || '';
      // CRO, Monitor, and Data Manager cannot add/delete subjects
      this.canAddDeleteSubjects = !['CRO', 'Monitor', 'Data Manager'].includes(this.userRole);
      
      this.studyDetails = {
        study_crc_id: null,
        study_name: 'N/A',
        study_code: 'N/A',
        site_location: 'N/A',
        subjects: [],
      };
    
      this.route.queryParamMap.subscribe(params => {
        // console.log('Query parameters:', params);
        // Store the passed site location from study-crc-list
        this.passedSiteLocation = params.get('centers') || 'N/A';
        
        this.studyDetails = {
          study_crc_id: params.get('studyCrcId') || 'N/A',
          study_name: params.get('name') || 'N/A',
          study_code: params.get('studyId') || 'N/A',
          site_location: this.passedSiteLocation, // Use the passed site location
          template_name: params.get('template_name') || 'N/A',
          template_id: params.get('template_id') || 'N/A'
        };
      });

      this.templateid = this.studyDetails.template_id || 'N/A';
    
      // Get studyCrcId from query parameters instead of route parameters
      this.studyCrcId = this.route.snapshot.queryParamMap.get('studyCrcId') || this.route.snapshot.paramMap.get('id') || '';
    
      if (this.studyCrcId && this.studyCrcId !== 'null') {
        this.fetchSubjectIds(this.studyCrcId,this.passedSiteLocation);
      } else {
        this.error = 'No assigned users found for this study';
        this.loading = false;
      }

      // if (this.studyDetails.template_name) {
      //   console.log('Getting template ID for template_name:', this.studyDetails.template_name);
      //   this.apiService.getTemplateId(this.studyDetails.template_name).subscribe(
      //     response => {
      //       console.log(`Template id Found: ${response.template_id}`);
      //       this.templateid = response.template_id;
      //       console.log('Template ID set to:', this.templateid);
      //     },
      //     error => {
      //       console.error('Error getting template ID:', error);
      //       this.templateid = null;
      //     }
      //   )
      // } else {
      //   console.log('No template_name found in study details');
      //   this.templateid = null;
      // }
    }
    
  // Handle form submission
  submitSubjectForm(): void {
    if (this.subjectForm.valid) {
      const formData = this.subjectForm.value;

      // Check if subjectId and studyCrcId are both available
      if (this.studyCrcId && formData.subjectId) { 
        // Prepare the data to send to API
        const apiData = { 
          studyCrcId: this.studyCrcId, 
          subjectId: formData.subjectId,
          participantId: formData.participantId || '',
          subjectInitial: formData.subjectInitial || ''
        };
        // console.log('Sending data to API:', apiData);
        this.apiService.addSubject(this.studyCrcId, this.passedSiteLocation, apiData).subscribe({
          next: (response) => {
            // console.log('Data inserted successfully:', response);
            alert('Subject added successfully!');
            this.fetchSubjectIds(this.studyCrcId, this.passedSiteLocation); // Fetch updated subject IDs
            
            // Clear the form and close the modal
            this.clearFormAndCloseModal();
          },
          error: (error) => {
            // console.log(error);
            // console.log('Error inserting data:', error.message);
            
            // Show alert with error message from response for 400 status only
            if (error?.status === 400) {
              let errorMessage = 'An error occurred while adding the subject. Please try again.';
              
              // Extract error message from response
              if (error.error) {
                // Check for error property (response format: { error: "..." })
                if (error.error.error && typeof error.error.error === 'string') {
                  errorMessage = error.error.error;
                } 
                // Check for message property
                else if (error.error.message && typeof error.error.message === 'string') {
                  errorMessage = error.error.message;
                } 
                // Check if error itself is a string
                else if (typeof error.error === 'string') {
                  errorMessage = error.error;
                }
              }
              // Check if message is directly on error object
              else if (error?.message && typeof error.message === 'string') {
                errorMessage = error.message;
              }
              
              // Show alert with the error message from response
              alert(errorMessage);
            } else {
              // For non-400 errors, show generic message
              alert('An error occurred while adding the subject. Please try again.');
            }
          }
        });
      } else {
        alert('Please ensure that both Subject ID and Study CRC ID are provided.');
      }
    } else {
      // console.log('Form is invalid.');
      alert('Please fill out the form correctly.');
    }
    // console.log('Study CRC ID:', this.studyCrcId);
    // console.log('Subject ID:', this.subjectForm.value.subjectId);
  }

  canManageFreezeLock(): boolean {
    const designation = this.currentUser?.designation || this.userRole || '';
    return designation === 'Monitor' || designation === 'Data Manager';
  }
loading: boolean = false;

  fetchSubjectIds(studyCrcId: string, site_location: string): void {
    this.loading = true; // Start loading
    this.apiService.getSubjectIds(studyCrcId, site_location).subscribe(
      (response) => {
        const data = response.data;
        if (data) {
          this.studyDetails = {  // Ensure study details are always set
            study_crc_id: data.study_crc_id || 'N/A',
            study_name: data.study_name || 'N/A',
            study_code: data.study_code || 'N/A',
            site_location: this.passedSiteLocation || data.site_location || 'N/A', // Preserve passed site location
          };
          const rawSubjects = data.subjects && data.subjects.length > 0 ? data.subjects : [];
          // Normalize so table and code can use subjectId (Screening ID), participantId, subjectInitial
          this.groupedStudies = rawSubjects.map((s: any) => ({
            ...s,
            subjectId: s.subjectId ?? s.subject_id ?? '',
            participantId: s.participantId ?? s.participant_id ?? '',
            subjectInitial: s.subjectInitial ?? s.subject_initial ?? '',
          }));
          const subjectIds = this.groupedStudies.map((s: any) => s.subjectId);
          if (subjectIds.length === 0) {
            this.groupedStudies.forEach((s: any) => { s.is_frozen = false; s.is_locked = false; });
            this.loading = false;
            return;
          }
          const study_id = data.subjects[0]?.study_id;
          this.apiService.fetchLockedFields({ locked_data_id: subjectIds, data_type: 'subject', study_id, subject_id: subjectIds }).subscribe(
            (res: any) => {
              const rows = res.data || [];
              const map: Record<string, { is_frozen: boolean; is_locked: boolean }> = {};
              rows.forEach((r: any) => {
                map[String(r.locked_data_id)] = {
                  is_frozen: !!(r.is_freezed ?? r.is_frozen),
                  is_locked: !!r.is_locked
                };
              });
              this.groupedStudies.forEach((s: any) => {
                const m = map[String(s.subjectId)];
                s.is_frozen = m ? m.is_frozen : false;
                s.is_locked = m ? m.is_locked : false;
              });
              this.loading = false;
            },
            (err) => { this.loading = false; console.error('Error fetching subject lock status:', err); }
          );
        } else {
          this.studyDetails = {
            study_crc_id: 'N/A',
            study_name: 'N/A',
            study_code: 'N/A',
            site_location: this.passedSiteLocation || 'N/A', // Preserve passed site location
          };
          this.groupedStudies = [];
          this.loading = false;
        }
      },
      (err) => {
         this.loading = false; // Stop loading
        this.error = 'Failed to load studies';
        console.error('Error fetching subject IDs:', err);
      }
    );
  }
  
  viewSubject(subject: any): void {
    // console.log('Subject clicked:', subject);
    // console.log('Template ID being passed:', this.templateid);
    // console.log('Study Details:', this.studyDetails);
    
    this.router.navigate(['study-template'], {
      queryParams: {
        studyId: subject.study_id,
        subjectId: subject.subjectId,
        study_id: subject.study_crc_id,
        study_name: this.studyDetails.study_name,
        study_code: this.studyDetails.study_code,
        site_location: this.studyDetails.site_location,
        subject_id: subject.subjectId,
        template_id: this.templateid,
        template_name: this.studyDetails.template_name      
      }
    })
  }

  deleteSubject(subject: any): void {
    // Check if subject is frozen or locked
    if (subject.is_frozen || subject.is_locked) {
      alert('This subject is ' + (subject.is_locked ? 'locked' : 'frozen') + '. No changes are allowed.');
      return;
    }
    
    if (confirm(`Are you sure you want to delete subject "${subject.subjectId}"? This action cannot be undone.`)) {
      this.apiService.deleteSubjectFromStudy(subject.subjectId).subscribe({
        next: (response) => {
          // console.log('Subject deleted successfully:', response);
          alert('Subject deleted successfully!');
          this.fetchSubjectIds(this.studyCrcId, this.passedSiteLocation); // Refresh the subject list
        },
        error: (error) => {
          console.error('Error deleting subject:', error);
          alert('An error occurred while deleting the subject.');
        }
      });
    }
  }

  clearFormAndCloseModal(): void {
    // Clear the form
    this.subjectForm.reset();
    this.subjectId = '';
    this.participantId = '';
    this.subjectInitial = '';
    
    // Close the modal using Bootstrap's modal API
    const modalElement = document.getElementById('exampleModal');
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  onModalClose(): void {
    // Clear the form when modal is closed manually
    this.subjectForm.reset();
    this.subjectId = '';
    this.participantId = '';
    this.subjectInitial = '';
  }

  openEditSubject(user: any): void {
    if (user.is_frozen || user.is_locked) {
      alert('This participant is ' + (user.is_locked ? 'locked' : 'frozen') + '. No changes are allowed.');
      return;
    }
    this.editingSubject = user;
    this.editSubjectForm.patchValue({
      subjectId: user.subjectId || '',
      participantId: user.participantId || '',
      subjectInitial: user.subjectInitial || '',
    });
    const modalElement = document.getElementById('editSubjectModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  submitEditSubjectForm(): void {
    if (this.editSubjectForm.valid && this.editingSubject) {
      const formData = this.editSubjectForm.value;
      const apiData = {
        subjectId: formData.subjectId,
        participantId: formData.participantId || '',
        subjectInitial: formData.subjectInitial || '',
      };
      this.apiService
        .updateSubject(
          this.studyCrcId,
          this.passedSiteLocation,
          this.editingSubject.subjectId,
          apiData
        )
        .subscribe({
          next: (response) => {
            alert('Participant updated successfully!');
            this.fetchSubjectIds(this.studyCrcId, this.passedSiteLocation);
            this.closeEditModal();
          },
          error: (error) => {
            if (error?.status === 400) {
              let errorMessage = 'An error occurred while updating the participant. Please try again.';
              if (error.error?.error && typeof error.error.error === 'string') {
                errorMessage = error.error.error;
              } else if (error.error?.message && typeof error.error.message === 'string') {
                errorMessage = error.error.message;
              } else if (typeof error.error === 'string') {
                errorMessage = error.error;
              }
              alert(errorMessage);
            } else {
              alert('An error occurred while updating the participant. Please try again.');
            }
          },
        });
    } else {
      alert('Please fill out the form correctly.');
    }
  }

  onEditModalClose(): void {
    this.editSubjectForm.reset();
    this.editingSubject = null;
  }

  closeEditModal(): void {
    const modalElement = document.getElementById('editSubjectModal');
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
    this.editSubjectForm.reset();
    this.editingSubject = null;
  }

  // Navigate back to the study list page
  goBack(): void {
    this.router.navigate(['/study-crc-list'], {
      queryParams: {
        name: this.studyDetails.name,
        studyId: this.studyDetails.studyId,
        centers: this.studyDetails.centers,
      }
    });
  }

  // ===========================================
  // FREEZE/UNFREEZE METHODS
  // ===========================================

  /**
   * Open freeze/unfreeze modal
   */
  freezeSubject(subject: any): void {
    if (!this.canManageFreezeLock()) {
      return;
    }
    this.currentSubject = subject;
    this.isFreezing = !subject.is_frozen;
    this.freezeEmail = '';
    this.freezePassword = '';
    this.freezeReason = '';
    this.freezeError = '';
    this.showFreezePassword = false;
    
    const modalElement = document.getElementById('freezeSubjectModal');
    if (modalElement) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modalElement);
      bootstrapModal.show();
    }
  }

  /**
   * Toggle freeze password visibility
   */
  toggleFreezePasswordVisibility(): void {
    this.showFreezePassword = !this.showFreezePassword;
  }

  /**
   * Authenticate and freeze/unfreeze subject
   */
  authenticateAndFreeze(): void {
    if (!this.freezeEmail || !this.freezePassword || !this.freezeReason) {
      this.freezeError = 'Please enter email, password, and reason';
      return;
    }

    this.freezeError = '';
    this.loading = true;

    const purpose = this.isFreezing ? 'freeze_subject' : 'unfreeze_subject';
    
    // Authenticate using the login API
    this.apiService.login(this.freezeEmail, this.freezePassword, purpose).subscribe(
      response => {
        // Authentication successful, now freeze/unfreeze the subject
        this.updateSubjectFreezeStatus();
      },
      error => {
        this.loading = false;
        this.freezeError = 'Invalid email or password. Please try again.';
        console.error('Authentication error:', error);
      }
    );
  }

  /**
   * Update subject freeze status
   */
  updateSubjectFreezeStatus(): void {
    if (!this.currentSubject) {
      this.loading = false;
      return;
    }

    const updateData = {
      locked_data_id: this.currentSubject.subjectId,
      subject_id: this.currentSubject.subjectId,
      study_id: this.currentSubject.study_id,
      is_frozen: this.isFreezing,
      is_locked: this.isLocked,
      locked_by: this.freezeEmail,
      reason: this.freezeReason
    };

    // Call lock-field API (updates both is_freezed and is_locked in locked_data)
    this.apiService.updateSubjectFreezeStatus(updateData).subscribe(
      response => {
        // Update local data
        const subjectIndex = this.groupedStudies.findIndex(s => 
          s.subjectId === this.currentSubject.subjectId
        );
        if (subjectIndex !== -1) {
          this.groupedStudies[subjectIndex].is_frozen = this.isFreezing;
        }
        
        this.loading = false;
        this.closeFreezeModal();
        alert(`Subject ${this.isFreezing ? 'frozen' : 'unfrozen'} successfully!`);
        this.fetchSubjectIds(this.studyCrcId, this.passedSiteLocation);
      },
      error => {
        console.error('Error updating subject freeze status:', error);
        this.loading = false;
        let errorMessage = 'Failed to update subject freeze status. Please try again.';
        if (error.error) {
          if (error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error.error) {
            errorMessage = error.error.error;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }
        }
        alert(errorMessage);
        this.freezeError = errorMessage;
      }
    );
  }

  /**
   * Close freeze modal
   */
  closeFreezeModal(): void {
    const modalElement = document.getElementById('freezeSubjectModal');
    if (modalElement) {
      const bootstrapModal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
    this.freezeEmail = '';
    this.freezePassword = '';
    this.freezeReason = '';
    this.freezeError = '';
    this.currentSubject = null;
  }

  // ===========================================
  // LOCK METHODS
  // ===========================================

  /**
   * Open lock subject modal
   */
  lockSubject(subject: any): void {
    if (!this.canManageFreezeLock()) {
      return;
    }
    if (subject.is_locked) {
      alert('This subject is already locked and cannot be unlocked.');
      return;
    }
    
    this.currentSubject = subject;
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockReason = '';
    this.lockError = '';
    this.showLockPassword = false;
    
    const modalElement = document.getElementById('lockSubjectModal');
    if (modalElement) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modalElement);
      bootstrapModal.show();
    }
  }

  /**
   * Toggle lock password visibility
   */
  toggleLockPasswordVisibility(): void {
    this.showLockPassword = !this.showLockPassword;
  }

  /**
   * Authenticate and lock subject
   */
  authenticateAndLock(): void {
    if (!this.lockEmail || !this.lockPassword || !this.lockReason) {
      this.lockError = 'Please enter email, password, and reason';
      return;
    }

    this.lockError = '';
    this.loading = true;

    const purpose = 'lock_subject';
    
    // Authenticate using the login API
    this.apiService.login(this.lockEmail, this.lockPassword, purpose).subscribe(
      response => {
        // Authentication successful, now lock the subject
        this.updateSubjectLockStatus();
      },
      error => {
        this.loading = false;
        this.lockError = 'Invalid email or password. Please try again.';
        console.error('Authentication error:', error);
      }
    );
  }

  /**
   * Update subject lock status
   */
  updateSubjectLockStatus(): void {
    if (!this.currentSubject) {
      this.loading = false;
      return;
    }

    const updateData = {
      locked_data_id: this.currentSubject.subjectId,
      subject_id: this.currentSubject.subjectId,
      study_id: this.currentSubject.study_id,
      is_locked: 1,
      locked_by: this.lockEmail,
      reason: this.lockReason
    };

    // Call lock-field API (same as freeze; updates is_locked in locked_data)
    this.apiService.updateSubjectLockStatus(updateData).subscribe(
      response => {
        // Update local data
        const subjectIndex = this.groupedStudies.findIndex(s => 
          s.subjectId === this.currentSubject.subjectId
        );
        if (subjectIndex !== -1) {
          this.groupedStudies[subjectIndex].is_locked = true;
        }
        
        this.loading = false;
        this.closeLockModal();
        alert('Subject locked successfully! This action cannot be undone.');
        this.fetchSubjectIds(this.studyCrcId, this.passedSiteLocation);
      },
      error => {
        console.error('Error updating subject lock status:', error);
        this.loading = false;
        let errorMessage = 'Failed to lock subject. Please try again.';
        if (error.error) {
          if (error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error.error) {
            errorMessage = error.error.error;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }
        }
        alert(errorMessage);
        this.lockError = errorMessage;
      }
    );
  }

  /**
   * Close lock modal
   */
  closeLockModal(): void {
    const modalElement = document.getElementById('lockSubjectModal');
    if (modalElement) {
      const bootstrapModal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockReason = '';
    this.lockError = '';
    this.currentSubject = null;
  }
}
